import { AppBar, Hidden, Icon, IconButton, MuiThemeProvider, Toolbar, withStyles } from '@material-ui/core';
import NavbarMobileToggleButton from 'app/Configs/fuse-layouts/shared-components/NavbarMobileToggleButton';
import AgendaPainel from 'app/Core/Components/AgendaPainel/AgendaPainel';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import * as Actions from 'app/store/actions';
import classNames from 'classnames';
import MobileDetect from 'mobile-detect';
import React from 'react';
import connect from 'react-redux/es/connect/connect';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    toolbarNovo: {
        backgroundColor: theme.palette.type === "dark" ? "#424242" : "#E6E6E6"//theme.palette.primary.main
    },
    separator: {
        width: 1,
        height: 64,
        backgroundColor: theme.palette.divider
    }
});

class ToolbarLayout1 extends XAPPComponent {

    state = {
        verAtalhos: false,
    };

    openAtalhos = () => {
        this.setState({ verAtalhos: !this.state.verAtalhos });
    }

    render() {
        const { classes, settings, toolbarTheme, xappRouteParams, navbarToggleMobile } = this.props;
        const layoutConfig = settings.layout.config;
        const { verAtalhos } = this.state;
        return (
            <MuiThemeProvider theme={toolbarTheme}>
                <AppBar id="fuse-toolbar" className={classNames(classes.toolbarNovo, "flex relative z-10")} color="default">
                    <Toolbar className="p-0">
                        <Hidden lgUp>
                            <IconButton
                                className="w-40 h-40 p-0"
                                onClick={navbarToggleMobile}
                            >
                                <Icon>menu</Icon>
                            </IconButton>
                        </Hidden>
                        <div className="flex-1" />
                        <div className={classes.separator} />
                        <AgendaPainel />
                        <div className={classes.separator} />

                        {layoutConfig.navbar.display && layoutConfig.navbar.position === 'right' && (
                            <Hidden lgUp>
                                <NavbarMobileToggleButton />
                            </Hidden>
                        )}
                    </Toolbar>
                </AppBar>
            </MuiThemeProvider>
        )
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        navbarToggleMobile: Actions.navbarToggleMobile
    }, dispatch);
}

function mapStateToProps({ fuse }) {
    return {
        settings: fuse.settings.current,
        toolbarTheme: fuse.settings.toolbarTheme
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ToolbarLayout1)));
